(function (angular, app) {
   "use strict";

   // Slider
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.calendar, CalendarDirective);

   CalendarDirective.$inject = [
      "$q"
      , "ngDialog"
        , app.modules.common.constants.calendarlist
        , app.modules.common.services.functions
        , app.modules.common.constants.appsettings
        , app.modules.outing.services.outings
   ];

   function CalendarDirective(
      $q
        , ngDialog
        , ggCalendar
        , ggFunctions
        , ggSettings
        , ggOutings
       ) {

      var ctrl = this;

      return {
         restrict: "E"
         , templateUrl: "app/ui/directives/calendar.html"
         , scope: {
            callback: "&"
         }
         , link: function (scope, element, attrs) {

            // Current Date
            var date = new Date();
            var pdate = new Date(); // Previous Month
            var ndate = new Date(); // Next Month
            var dday = date.getUTCDate();
            var mmonth = date.getUTCMonth();
            var yyear = date.getUTCFullYear();
            var groupList = [];

            // --- SCOPE ---

            // vars
            scope.isLoaded = false;
            scope.isProcessing = false;
            scope.Calendar = {
               monthName: "January"
               , month : 0
               , year: yyear
               , date : date
            }
            scope.Month = [];
            scope.Outings = [];
            scope.Day = {
               name: "Sunday"
               , number: 1
               , isPast: false
               , outings : []
            }


            scope.isHandicapEnabled = function () {
               return ggSettings.isHCP;
            }

            // methods
            scope.nextMonth = function (n) {
               // get next month date
               date = getNextMonth(n);
               
               // Fetch events & re-render calendar
               loadCalendar();
            }
            scope.select = function (weekindex, dayindex) {

               var day = scope.Month[weekindex][dayindex];
               scope.Day = day;

               // is day in past?
               var selectedDate = new Date ((mmonth+1) + '/' + scope.Day.number + '/' + yyear);
               var realDate = new Date();

               if (selectedDate >= realDate) {
                  scope.Day.isOuting = true;
               } else {
                  scope.Day.isOuting = false;
               }

               // Close any open dialog
               ngDialog.closeAll();
               // Open Outing Dialog
               ngDialog.open({
                  template: "app/ui/directives/calendar-day.html"
                 , closeByEscape: true
                 , closeByDocument: true
                 , className: "fullscreen calendar"
                 , scope: scope
              });

            }

            scope.selectOuting = function (outingId) {
               // Close any open dialog
               ngDialog.closeAll();

               ggFunctions.goToPage(app.modules.outing.routes.detail.path + "?outingId=" + outingId);
            }
            scope.clickScore = function () {
               var playDate = ggFunctions.formatDateString((mmonth + 1) + '/' + scope.Day.number + '/' + yyear, 'yyyy-mm-dd', null);
               // Close any open dialog
               ngDialog.closeAll();
               ggFunctions.goToPage(app.modules.scoring.routes.postascore.path + "?playDate=" + playDate);
            }
            scope.clickOuting = function () {
               var playDate = ggFunctions.formatDateString((mmonth + 1) + '/' + scope.Day.number + '/' + yyear, 'yyyy-mm-dd', null);
               // Close any open dialog
               ngDialog.closeAll();
               ggFunctions.goToPage(app.modules.outing.routes.setup.path + "?playDate="+playDate);
            }
            scope.isToday = function(mm, d, y) {
               var rv = false;
               var date1 = ggFunctions.formatDate((mm) + '/' + d + '/' + y, 'yyyy-mm-dd', true);
               var date2 = ggFunctions.formatDate(null, 'yyyy-mm-dd', true);
               if (date1 == date2) {
                  rv = true;
               }
               return rv;
            }

            scope.getThemeName = function(themeId){
               return ggFunctions.fetchThemeById(themeId).className;
            }
            // ------------------

            var loadOptions = function (objStr) {

               var preloaded = false;
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {
                     if (obj.preload) {
                        preloaded = true;
                     }
                  }
               }



               pdate = getNextMonth(-1);
               ndate = getNextMonth(1);





               // set global
               dday = date.getUTCDate();
               mmonth = date.getUTCMonth();
               yyear = date.getUTCFullYear();

               // Fetch Events -> Thend Render
               if (preloaded) {
                  fetchOutings();
               } else {
                  renderCalendar();
               }
               
            }
            , loadCalendar = function () {
               pdate = getNextMonth(-1);
               ndate = getNextMonth(1);

               // set global
               dday = date.getUTCDate();
               mmonth = date.getUTCMonth();
               yyear = date.getUTCFullYear();

               // Fetch Events -> Thend Render
               fetchOutings();
            }
            , fetchOutings = function () {

                  var form = {
                     startOn: getNextMonth(-1)
                     , endOn: getNextMonth(2)
                     , memberId: app.Member.Detail.id
                     , className : "Public"
                  }
                  scope.isProcessing = true;
                   ggOutings.search.fetchOutingsByMembership(form).then(function (data) {
                     if (data && data.status == "200") {
                        scope.Outings = data.data.value;
                     }
                  }, function (error) {
                     console.log(error)
                  }).finally(function () {
                     scope.isProcessing = false;
                     renderCalendar();
                  });


               
            }
            , renderCalendar = function() {

               // update calendar name
               scope.Calendar.monthName = ggCalendar[mmonth].month;
               scope.Calendar.month = ggCalendar[mmonth].index + 1;
               scope.Calendar.year = yyear;
               scope.Calendar.date = date;

               // With the date selected
               var td  = (mmonth + 1) + "/1/" + yyear; // Today
               var tdd = new Date(td)    // Date Object
               var sd  = tdd.getDay();   // Day Start Index
               var tdc = getDayCount(mmonth, yyear); // Day Count in Month

               // I need the previous day count to show leading days on calendar
               var pdc = 30;
               if (mmonth == 0) {
                  // Previous month
                  pdc = getDayCount(mmonth - 1, yyear);
               }else{
                  // December previous year   
                  pdc = getDayCount(11, yyear - 1);
               }

               // Build Weeks
               var nxt = 1;
               var prv = pdc - (sd-1);  // Previous month starts minus this months startday +index +index
               var addMonth = 0;
               var month = [];
               for (var w = 0; w < 6; w++) {
                  var week = [];
                  for (var d = 0; d < 7; d++) {

                     // Week * 7 + day
                     var number = ((w * 7) + (d + 1) - sd);
                     var ldate  = (date.getUTCMonth() + 1) + "/" + number + "/" + date.getUTCFullYear();
                     addMonth = 0;
                     // Previous Month start
                     if (w == 0 && d < sd) {
                        number = prv;
                        prv++;
                        addMonth = -1;

                        ldate = (pdate.getUTCMonth() + 1) + "/" + number + "/" + pdate.getUTCFullYear();

                     } else {
                        if (number > tdc) {
                           number = nxt;
                           addMonth = 1;
                           nxt++;
                           ldate = (ndate.getUTCMonth() + 1) + "/" + number + "/" + ndate.getUTCFullYear();
                        }
                     }
                     
                     var day = {};
                     day.addMonth = addMonth;
                     day.week = w;
                     day.index = d;
                     day.number = number;
                     day.name = getWeekDayName(d);
                     day.outings = [];

                     // Check for any outings on this day // only in current month
                     var outings = [];
                     if (addMonth == 0){
                        for (var o = 0; o < scope.Outings.length; o++) {
                           var fsd = scope.Outings[o].startOn;
                           if (isDateEq(ldate, fsd)) {
                              outings.push(scope.Outings[o]);
                           }
                        }
                     }
                     day.outings = outings;

                     // Push the day into the week array.
                     week.push(day);
                  }
                  // Push week into month array
                  month.push(week);
                  if (addMonth > 0){
                     break;
                  }
               }
               scope.Month = month;
               scope.isLoaded = true;
            }
            , getDayCount = function(m, y) {
               if (m == -1) {
                  // default 31 days.
                  return 31;
               } else {
                  // check month for days
                  var dc = ggCalendar[m].days;
                  if (m == 1) { // February Leap Year
                     for (var x = 1904; x < 2041;) {
                        if (y == x) {
                           dc = 29;
                        }
                        x = x + 4;
                     }
                  }
                  return dc;
               }
            }
            ,  getWeekDayName = function(d) {
               switch (d) {
                  case 0:
                     return "Sunday";
                     break;
                  case 1:
                     return "Monday";
                     break;
                  case 2:
                     return "Tuesday";
                     break;
                  case 3:
                     return "Wednesday";
                     break;
                  case 4:
                     return "Thursday";
                     break;
                  case 5:
                     return "Friday";
                     break;
                  case 6:
                     return "Saturday";
                     break;
               }
            }
            , getNextMonth = function(n){
               var gnd = dday;
               var gnm = mmonth;
               var gny = yyear;
               if (n > 0) {
                  if (gnm + n > 11) {
                     gny++;
                     gnm = (gnm - 12) + n
                  } else {
                     gnm = gnm + n;
                  }
               } else {
                  if (gnm == 0) {
                     gnm = 11;
                     gny--;
                  } else {
                     gnm--;
                  }
               }
               var newDate = new Date((gnm+1) + '/1/' + gny); 
               return newDate;
              
            }
            , isDateEq = function(date1, date2) {
               var rv = false;
               if (date1 && date2) {
                  var d1 = new Date(date1);
                  var d2 = new Date(date2);
                  
                  if (d1.getUTCFullYear() == d2.getUTCFullYear()) {
                     if (d1.getUTCMonth() == d2.getUTCMonth()) {
                        if (d1.getUTCDate() == d2.getUTCDate()) {
                           rv = true;
                        }
                     }
                  }
               }

               return rv;
            }
            

            ////////////////////////////////////////

            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr);
               }
            });

            if (attrs.id) {
               elementId = attrs.id;
            }
            if (attrs.options) {
               var optStr = attrs.options;
               loadOptions(optStr);
            }
         }
      }
   }
}(angular, app));
